import { useToasts } from "@/lib/store";
import { Icon } from "./Icon";
import { cx } from "@/lib/cx";

/** Feedback com acao "Tentar de novo"/desfazer (RF-UX-058/060). */
export function Toasts() {
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);
  if (toasts.length === 0) return null;
  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-toast flex flex-col items-center gap-2 px-4 pb-24 expanded:pb-6"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cx(
            "pointer-events-auto flex w-full max-w-[420px] items-center gap-3 rounded-md border bg-surface px-4 py-3 text-[13px] shadow-card",
            toast.tone === "danger" && "border-[#fecaca]",
            toast.tone === "success" && "border-[#bbf7d0]",
          )}
          role={toast.tone === "danger" ? "alert" : "status"}
        >
          <span className="flex-1">{toast.message}</span>
          {toast.actionLabel ? (
            <button
              type="button"
              className="btn ghost min-h-0 px-2 py-1 text-xs"
              onClick={() => {
                toast.onAction?.();
                dismiss(toast.id);
              }}
            >
              {toast.actionLabel}
            </button>
          ) : null}
          <button
            type="button"
            className="icon-btn h-8 w-8"
            aria-label="Fechar aviso"
            onClick={() => dismiss(toast.id)}
          >
            <Icon name="close" size={16} />
          </button>
        </div>
      ))}
    </div>
  );
}
